import { CONFIG } from 'app/core/config';
import { ViewModel } from '../view-model';
import { RunnableLookupItemState } from './runnable-lookup-item-state';

export class RunnableLookupRowsRangeDeleteDataRow implements ViewModel {

  readonly friendlyTypeNameSingular = 'RunnableLookupRowsRangeDeleteDataRow';
  readonly apiRoute: string = CONFIG.apiRoutes.RunnableLookupRows;

  lookupRowId: string;
  rowIndex: number;
  state: RunnableLookupItemState = RunnableLookupItemState.Unchanged;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.lookupRowId = data.lookupRowId;
    this.rowIndex = data.rowIndex;
  }
}

